import { ToastContainer } from "react-toastify"
import { useActiveTheme } from "./theme-provider"

export function ToastThemeProvider() {
  const activeTheme = useActiveTheme()

  return <ToastContainer position="bottom-right" theme={activeTheme === "dark" ? "dark" : "light"} />
}
